import React from "react";
import { Phone, Mail } from "lucide-react";
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer
      className="text-white py-8 px-8"
      style={{
        background: 'linear-gradient(135deg, #1D3A50, #182F40)',
      }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-10">

        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img
            src={logo}
            alt="CAF Online Logo"
            className="h-20 w-auto" // Bigger logo
          />
        </div>

        {/* Contact Now */}
        <div className="flex flex-col items-center md:items-start space-y-3 w-full md:w-auto">
          <h3 className="font-bold uppercase">Contatta Ora!</h3>
          <form className="flex space-x-2 w-full md:w-auto">
            <input
              type="text"
              placeholder="Scrivi il tuo messaggio...."
              className="w-full md:w-64 rounded-md px-3 py-2 text-black placeholder-gray-500 focus:outline-none"
            />
            <button
              type="submit"
              className="font-semibold px-5 py-2 rounded text-black shadow"
              style={{
                background: 'linear-gradient(135deg, #F2C231, #C69A32)',
              }}
            >
              Invia
            </button>
          </form>
          <a href="/terms-and-conditions" className="underline text-sm">
            Termini e Condizioni
          </a>
          <a href="/privacy-policy" className="underline text-sm mt-1">
            Informativa sulla Privacy
          </a>
          <a href="/cookie-policy" className="underline text-sm mt-1">
            Cookie Policy
          </a>
          <a href="mailto:cafpraticheonline@gmail.com" className="underline text-sm mt-1">
            Privacy Contact / DPO
          </a>
          <a href="/privacy-policy#do-not-sell" className="underline text-sm mt-1">
            Do Not Sell My Personal Information
          </a>
        </div>

        {/* Contact Details */}
        <div className="flex flex-col items-center md:items-start space-y-2 text-sm font-semibold">
          <h3 className="uppercase font-bold mb-1">Dettagli di Contatto</h3>
          <div className="flex items-center space-x-2">
            <Phone size={18} />
            <span><a
              href="tel:+393428439658"
              className="hover:underline text-inherit"
            >
              +39 342 843 9658
            </a></span>
          </div>
          <div className="flex items-center space-x-2">
            <Mail size={18} />
            <span><a
              href="mailto: cafpraticheonline@gmail.com"
              className="hover:underline text-inherit"
            >
              cafpraticheonline@gmail.com
            </a></span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
